import React, { useState } from 'react';
import 'antd-mobile/es/list/style/css';
import _List from 'antd-mobile/es/list';
import { createForm } from '@formily/core';
import { connect, mapProps, observer, useForm, createSchemaField, FormProvider, FormConsumer } from '@formily/react';
import 'antd-mobile/es/input-item/style/css';
import _InputItem from 'antd-mobile/es/input-item';
import 'antd-mobile/es/textarea-item/style/css';
import _TextareaItem from 'antd-mobile/es/textarea-item';
import 'antd-mobile/es/date-picker/style/css';
import _DatePicker from 'antd-mobile/es/date-picker';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import 'antd-mobile/es/checkbox/style/css';
import _Checkbox from 'antd-mobile/es/checkbox';
import 'antd-mobile/es/switch/style/css';
import _Switch from 'antd-mobile/es/switch';
import 'antd-mobile/es/picker/style/css';
import _Picker from 'antd-mobile/es/picker';
import 'antd-mobile/es/image-picker/style/css';
import _ImagePicker from 'antd-mobile/es/image-picker';
import 'antd-mobile/es/radio/style/css';
import _Radio from 'antd-mobile/es/radio';
import 'antd-mobile/es/calendar/style/css';
import _Calendar from 'antd-mobile/es/calendar';
import 'antd-mobile/es/range/style/css';
import _Range from 'antd-mobile/es/range';
import 'antd-mobile/es/slider/style/css';
import _Slider from 'antd-mobile/es/slider';
import 'antd-mobile/es/stepper/style/css';
import _Stepper from 'antd-mobile/es/stepper';
import BraftEditor from 'braft-editor';
import 'braft-editor/dist/index.css';
import RcColorPicker from 'rc-color-picker';
import 'rc-color-picker/assets/index.css';
import 'antd-mobile/es/button/style/css';
import _Button from 'antd-mobile/es/button';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".container {\n  display: flex;\n  align-items: center;\n}\n.container .label {\n  padding-left: 30px;\n  font-size: 16px;\n}\n.container .itemContent {\n  flex: 1;\n  height: 100%;\n}\n.am-list-content {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n";
styleInject(css_248z);

var Item = _List.Item;

var ListItem = function ListItem(props) {
  var title = props.title,
      children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: css_248z.container
  }, /*#__PURE__*/React.createElement("span", {
    className: css_248z.label
  }, title), /*#__PURE__*/React.createElement(Item, _extends({
    className: css_248z.itemContent
  }, props), children));
};

var FormItem = connect(ListItem, mapProps({
  title: true,
  description: 'extra',
  required: true,
  validateStatus: true
}, function (props) {
  return _objectSpread2({}, props);
}));

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var classnames = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

var _excluded = ["displayType", "title", "required", "errorMessage", "allowClear", "addonBefore", "addonAfter"];

var InputRaw = function InputRaw(props) {
  console.log('props: ', props);

  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      errorMessage = props.errorMessage,
      allowClear = props.allowClear,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter,
      restProps = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(_InputItem, restProps, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Input = connect(InputRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    clear: props.allowClear,
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$1 = ["displayType", "title", "required", "onChange", "errorMessage", "allowClear", "addonBefore", "addonAfter"];

var InputNumberRaw = function InputNumberRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      allowClear = props.allowClear,
      addonBefore = props.addonBefore,
      addonAfter = props.addonAfter,
      restProps = _objectWithoutProperties(props, _excluded$1);

  var handleChange = function handleChange(value) {
    var numberString = value.replace(/\D/g, '');
    onChange(numberString ? parseInt(numberString, 10) : undefined);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(_InputItem, _extends({
    type: "number",
    onChange: handleChange
  }, restProps), displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var InputNumber = connect(InputNumberRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    clear: props.allowClear,
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$2 = ["displayType", "title", "required", "errorMessage", "allowClear"];

var TextareaRaw = function TextareaRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      errorMessage = props.errorMessage,
      allowClear = props.allowClear,
      restProps = _objectWithoutProperties(props, _excluded$2);

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(_TextareaItem, _extends({
    title: displayType === 'row' && /*#__PURE__*/React.createElement("label", {
      className: classnames({
        required: required,
        'label-row': true
      })
    }, title)
  }, restProps)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Textarea = connect(TextareaRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    clear: props.allowClear,
    autoHeight: props.autoSize,
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$3 = ["displayType", "title", "required", "value", "onChange", "errorMessage"];
dayjs.extend(customParseFormat);
var ListItem$1 = _List.Item;

var CustomChildren = function CustomChildren(props) {
  var value = props.value,
      onClick = props.onClick,
      children = props.children;
  var valueText = value;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "customPickerChildren"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentBox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "childrenLeft"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "childrenRight"
  }, '请选择')), valueText && /*#__PURE__*/React.createElement("div", {
    className: "childrenValue"
  }, valueText));
};

var DatePickerRaw = function DatePickerRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$3);

  console.log('datapicker props: ', props);
  var valueDate = value ? dayjs(value, 'YYYY-MM-DD').toDate() : undefined;

  var onOk = function onOk(e) {
    var ymd = dayjs(e).format('YYYY-MM-DD');
    onChange(ymd);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_DatePicker, _extends({
    mode: "date"
  }, restProps, {
    value: valueDate,
    onOk: onOk
  }), displayType === 'column' ? /*#__PURE__*/React.createElement(CustomChildren, {
    value: value
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column label-column-no-gutter': true
    })
  }, title)) : /*#__PURE__*/React.createElement(ListItem$1, {
    arrow: "horizontal"
  }, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title))), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var DatePicker = connect(DatePickerRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var css_248z$1 = ".am-checkbox-agree .am-checkbox {\n  left: unset !important;\n  right: 0 !important;\n  width: 21px !important;\n}\n";
styleInject(css_248z$1);

var _excluded$4 = ["displayType", "title", "required", "value", "onChange", "errorMessage"];
var ListItem$2 = _List.Item;
var AgreeItem = _Checkbox.AgreeItem;

var CheckboxBooleanRaw = function CheckboxBooleanRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$4);

  var onCheckboxChange = function onCheckboxChange(e) {
    onChange(e.target.checked);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(ListItem$2, {
    extra: /*#__PURE__*/React.createElement(AgreeItem, _extends({}, restProps, {
      value: value,
      onChange: onCheckboxChange
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        color: 'transparent'
      }
    }, "\u5360\u4F4D"))
  }, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var CheckboxBoolean = connect(CheckboxBooleanRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var css_248z$2 = "";
styleInject(css_248z$2);

var _excluded$5 = ["displayType", "title", "required", "errorMessage"];
var ListItem$3 = _List.Item;

var SwitchRaw = function SwitchRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$5);

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(ListItem$3, {
    extra: /*#__PURE__*/React.createElement(_Switch, _extends({
      color: "#108ee9"
    }, restProps))
  }, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Switch = connect(SwitchRaw, mapProps({
  title: true,
  description: 'extra',
  required: true,
  value: 'checked'
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$6 = ["displayType", "title", "required", "options", "onChange", "errorMessage"];
var ListItem$4 = _List.Item;
var CheckboxItem = _Checkbox.CheckboxItem;

var CheckboxGroupRaw = function CheckboxGroupRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      options = props.options,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$6);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      currentList = _useState2[0],
      setCurrentList = _useState2[1];

  var onListChange = function onListChange(e, index) {
    var checked = e.target.checked;
    var currentValue = options[index].value;
    var currentIndexInList = currentList.findIndex(function (item) {
      return item === currentValue;
    });
    var list;

    if (checked) {
      list = currentList.concat(options[index].value);
    } else {
      currentList.splice(currentIndexInList, 1);
      list = currentList;
    }

    setCurrentList(list);
    onChange(list);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement(ListItem$4, null, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: 24
    }
  }, options.map(function (i, index) {
    return /*#__PURE__*/React.createElement(CheckboxItem, _extends({}, restProps, {
      key: i.value,
      onChange: function onChange(e) {
        return onListChange(e, index);
      }
    }), i.label);
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var CheckboxGroup = connect(CheckboxGroupRaw, mapProps({
  title: true,
  description: 'extra',
  required: true,
  dataSource: 'options'
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$7 = ["displayType", "title", "required", "value", "onChange", "data", "errorMessage"];
var ListItem$5 = _List.Item;

var CustomChildren$1 = function CustomChildren(props) {
  var _data$find;

  var data = props.data,
      value = props.value,
      onClick = props.onClick,
      children = props.children;
  var valueText = data === null || data === void 0 ? void 0 : (_data$find = data.find(function (item) {
    return item.value === (value === null || value === void 0 ? void 0 : value[0]);
  })) === null || _data$find === void 0 ? void 0 : _data$find.label;
  return /*#__PURE__*/React.createElement("div", {
    onClick: onClick,
    className: "customPickerChildren"
  }, /*#__PURE__*/React.createElement("div", {
    className: "contentBox"
  }, /*#__PURE__*/React.createElement("div", {
    className: "childrenLeft"
  }, children), /*#__PURE__*/React.createElement("div", {
    className: "childrenRight"
  }, '请选择')), valueText && /*#__PURE__*/React.createElement("div", {
    className: "childrenValue"
  }, valueText));
};

var PickerRaw = function PickerRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      data = props.data,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$7);

  console.log('picker props: ', props);

  var onOk = function onOk(e) {
    onChange(e);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Picker, _extends({}, restProps, {
    cols: "1",
    data: data,
    value: value,
    onOk: onOk
  }), displayType === 'column' ? /*#__PURE__*/React.createElement(CustomChildren$1, {
    data: data,
    value: value
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column label-column-no-gutter': true
    })
  }, title)) : /*#__PURE__*/React.createElement(ListItem$5, {
    arrow: "horizontal"
  }, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title))), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Picker = connect(PickerRaw, mapProps({
  title: true,
  description: 'extra',
  required: true,
  dataSource: 'data'
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$8 = ["displayType", "title", "required", "errorMessage"];
var ListItem$6 = _List.Item;

var ImagePickerRaw = function ImagePickerRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$8);

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(ListItem$6, null, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title), /*#__PURE__*/React.createElement(_ImagePicker, restProps)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var ImagePicker = connect(ImagePickerRaw, mapProps({
  title: true,
  description: 'extra',
  required: true,
  value: 'files',
  onInput: 'onChange'
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$9 = ["displayType", "title", "required", "options", "onChange", "errorMessage"];
var ListItem$7 = _List.Item;
var RadioItem = _Radio.RadioItem;

var RadioGroupRaw = function RadioGroupRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      options = props.options,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$9);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      currentRadio = _useState2[0],
      setCurrentRadio = _useState2[1];

  var onListChange = function onListChange(value) {
    setCurrentRadio(value);
    onChange(value);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement(ListItem$7, null, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: 24
    }
  }, options.map(function (i) {
    return /*#__PURE__*/React.createElement(RadioItem, _extends({}, restProps, {
      key: i.value,
      checked: currentRadio === i.value,
      onChange: function onChange() {
        return onListChange(i.value);
      }
    }), i.label);
  })), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var RadioGroup = connect(RadioGroupRaw, mapProps({
  title: true,
  description: 'extra',
  required: true,
  validateStatus: true,
  dataSource: 'options'
}, function (props, field) {
  return _objectSpread2(_objectSpread2({}, props), {}, {
    errors: field.errors
  });
}));

var _excluded$a = ["displayType", "disabled", "title", "required", "value", "onChange", "errorMessage"];
var ListItem$8 = _List.Item;

var CalendarRaw = function CalendarRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      disabled = props.disabled,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$a);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var _useState3 = useState(undefined),
      _useState4 = _slicedToArray(_useState3, 2),
      selectedRange = _useState4[0],
      setSelectedRange = _useState4[1];

  var onClick = function onClick() {
    if (disabled) return;
    setShow(true);
  };

  var onConfirm = function onConfirm(startDate, endDate) {
    onChange([startDate, endDate]);
    setShow(false);
    setSelectedRange([startDate, endDate]);
  };

  var onCancel = function onCancel() {
    setShow(false);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(ListItem$8, {
    arrow: "horizontal",
    wrap: true,
    multipleLine: true,
    extra: selectedRange ? "".concat(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange[0], " \u81F3 ").concat(selectedRange === null || selectedRange === void 0 ? void 0 : selectedRange[1]) : '请选择',
    onClick: onClick
  }, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage), /*#__PURE__*/React.createElement(_Calendar, _extends({}, restProps, {
    visible: show,
    defaultValue: selectedRange,
    onConfirm: onConfirm,
    onCancel: onCancel
  })));
};

var Calendar = connect(CalendarRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  var now = new Date();
  return _objectSpread2(_objectSpread2({}, props), {}, {
    defaultDate: now,
    minDate: new Date(+now - 5184000000),
    maxDate: new Date(+now + 31536000000),
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$b = ["displayType", "title", "required", "value", "onChange", "errorMessage"];
var ListItem$9 = _List.Item;

var RangeRaw = function RangeRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$b);

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$9, null, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      'custom-range-container': true,
      'custom-range-container-column': displayType === 'row'
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "custom-range-label"
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "custom-range-content"
  }, /*#__PURE__*/React.createElement(_Range, _extends({
    value: value,
    onChange: onSliderChange
  }, restProps)), /*#__PURE__*/React.createElement("span", {
    className: "range-value-text"
  }, value)))), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Range = connect(RangeRaw, mapProps({
  title: true,
  description: 'extra',
  required: true,
  onInput: 'onAfterChange'
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errors: field.errors,
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var css_248z$3 = ".custom-slider-container {\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.custom-slider-container .custom-slider-label {\n  margin-right: 10px;\n}\n.custom-slider-container .custom-slider-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n.custom-slider-container .custom-slider-content .am-slider-wrapper {\n  flex: 1;\n  padding: 0 10px;\n}\n.custom-slider-container .custom-slider-content .slider-value-text {\n  margin-left: 10px;\n}\n.custom-slider-container-column {\n  flex-direction: column;\n  align-items: flex-start;\n}\n.custom-slider-container-column .custom-slider-content {\n  width: 100%;\n  flex: unset;\n  height: 30px;\n}\n";
styleInject(css_248z$3);

var _excluded$c = ["displayType", "title", "required", "value", "onChange", "errorMessage"];
var ListItem$a = _List.Item;

var SliderRaw = function SliderRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$c);

  var onSliderChange = function onSliderChange(value) {
    onChange(value);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$a, null, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      'custom-slider-container': true,
      'custom-slider-container-column': displayType === 'column'
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "custom-slider-label"
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': displayType === 'column',
      'label-row': displayType === 'row'
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "custom-slider-content"
  }, /*#__PURE__*/React.createElement(_Slider, _extends({
    value: value,
    onChange: onSliderChange
  }, restProps)), /*#__PURE__*/React.createElement("span", {
    className: "slider-value-text"
  }, value)))), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Slider = connect(SliderRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$d = ["displayType", "title", "required", "errorMessage"];
var ListItem$b = _List.Item;

var StepperRaw = function StepperRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      title = props.title,
      required = props.required,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$d);

  return /*#__PURE__*/React.createElement(React.Fragment, null, displayType === 'column' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': true
    })
  }, title), /*#__PURE__*/React.createElement(ListItem$b, {
    extra: /*#__PURE__*/React.createElement(_Stepper, restProps)
  }, displayType === 'row' && /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-row': true
    })
  }, title)), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var Stepper = connect(StepperRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$e = ["title", "required", "onChange", "errorMessage"];
var ListItem$c = _List.Item;

var RichEditorRaw = function RichEditorRaw(props) {
  var title = props.title,
      required = props.required,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$e);

  var _useState = useState(function () {
    return BraftEditor.createEditorState('<p>Hello <b>World!</b></p>');
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  var handleChange = function handleChange(e) {
    var html = e.toHTML();
    setValue(e.toHTML());
    onChange(html);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$c, null, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required
    })
  }, title)), /*#__PURE__*/React.createElement(ListItem$c, null, /*#__PURE__*/React.createElement(BraftEditor, _extends({}, restProps, {
    value: value,
    onChange: handleChange
  }))), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var RichEditor = connect(RichEditorRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var css_248z$4 = ".custom-color-picker-container {\n  display: flex;\n  align-items: center;\n}\n.custom-color-picker-container .color-picker-title {\n  margin-right: 10px;\n}\n.custom-color-picker-container .custom-color-picker-content {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n.custom-color-picker-container .custom-color-picker-content .custom-color-picker-mask {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  z-index: 2;\n  background: transparent;\n}\n.custom-color-picker-container .custom-color-picker-content .custom-color-picker .react-custom-trigger {\n  display: inline-block;\n  width: 120px;\n  height: 32px;\n  margin-top: 8px;\n  border: 1px solid #ccc;\n}\n.custom-color-picker-container .custom-color-picker-content .color-picker-text {\n  margin-left: 10px;\n}\n.custom-color-picker-container-column {\n  flex-direction: column;\n  align-items: flex-start;\n}\n";
styleInject(css_248z$4);

var _excluded$f = ["displayType", "disabled", "title", "required", "value", "onChange", "errorMessage"];
var ListItem$d = _List.Item;
var alphaHexMap = {
  '1.00': 'FF',
  '0.99': 'FC',
  '0.98': 'FA',
  '0.97': 'F7',
  '0.96': 'F5',
  '0.95': 'F2',
  '0.94': 'F0',
  '0.93': 'ED',
  '0.92': 'EB',
  '0.91': 'E8',
  '0.90': 'E6',
  '0.89': 'E3',
  '0.88': 'E0',
  '0.87': 'DE',
  '0.86': 'DB',
  '0.85': 'D9',
  '0.84': 'D6',
  '0.83': 'D4',
  '0.82': 'D1',
  '0.81': 'CF',
  '0.80': 'CC',
  '0.79': 'C9',
  '0.78': 'C7',
  '0.77': 'C4',
  '0.76': 'C2',
  '0.75': 'BF',
  '0.74': 'BD',
  '0.73': 'BA',
  '0.72': 'B8',
  '0.71': 'B5',
  '0.70': 'B3',
  '0.69': 'B0',
  '0.68': 'AD',
  '0.67': 'AB',
  '0.66': 'A8',
  '0.65': 'A6',
  '0.64': 'A3',
  '0.63': 'A1',
  '0.62': '9E',
  '0.61': '9C',
  '0.60': '99',
  '0.59': '96',
  '0.58': '94',
  '0.57': '91',
  '0.56': '8F',
  '0.55': '8C',
  '0.54': '8A',
  '0.53': '87',
  '0.52': '85',
  '0.51': '82',
  '0.50': '80',
  '0.49': '7D',
  '0.48': '7A',
  '0.47': '78',
  '0.46': '75',
  '0.45': '73',
  '0.44': '70',
  '0.43': '6E',
  '0.42': '6B',
  '0.41': '69',
  '0.40': '66',
  '0.39': '63',
  '0.38': '61',
  '0.37': '5E',
  '0.36': '5C',
  '0.35': '59',
  '0.34': '57',
  '0.33': '54',
  '0.32': '52',
  '0.31': '4F',
  '0.30': '4D',
  '0.29': '4A',
  '0.28': '47',
  '0.27': '45',
  '0.26': '42',
  '0.25': '40',
  '0.24': '3D',
  '0.23': '3B',
  '0.22': '38',
  '0.21': '36',
  '0.20': '33',
  '0.19': '30',
  '0.18': '2E',
  '0.17': '2B',
  '0.16': '29',
  '0.15': '26',
  '0.14': '24',
  '0.13': '21',
  '0.12': '1F',
  '0.11': '1C',
  '0.10': '1A',
  '0.09': '17',
  '0.08': '14',
  '0.07': '12',
  '0.06': '0F',
  '0.05': '0D',
  '0.04': '0A',
  '0.03': '08',
  '0.02': '05',
  '0.01': '03',
  '0.00': '00'
}; // 获取透明度

var getAlphaFromHex = function getAlphaFromHex() {
  var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '#ffffff';
  var alphaHex = hex.slice(7);
  var alpha = 100;
  Object.entries(alphaHexMap).some(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    var flag = false;

    if (value === alphaHex.toUpperCase()) {
      alpha = Number(key) * 100;
      flag = true;
    }

    return flag;
  });
  return alpha;
};

var ColorPickerRaw = function ColorPickerRaw(props) {
  var _props$displayType = props.displayType,
      displayType = _props$displayType === void 0 ? 'row' : _props$displayType,
      disabled = props.disabled,
      title = props.title,
      required = props.required,
      value = props.value,
      onChange = props.onChange,
      errorMessage = props.errorMessage,
      restProps = _objectWithoutProperties(props, _excluded$f);

  var onPickerChange = function onPickerChange(e) {
    var alphaHex = alphaHexMap[(e.alpha / 100).toFixed(2)];
    var hex = e.color + (e.alpha === 100 ? '' : alphaHex);
    onChange(hex);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListItem$d, null, /*#__PURE__*/React.createElement("div", {
    className: classnames({
      "custom-color-picker-container": true,
      'custom-color-picker-container-column': displayType === 'column'
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: "color-picker-title"
  }, /*#__PURE__*/React.createElement("label", {
    className: classnames({
      required: required,
      'label-column': displayType === 'column',
      'label-row': displayType === 'row'
    })
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: "custom-color-picker-content"
  }, disabled && /*#__PURE__*/React.createElement("div", {
    className: "custom-color-picker-mask"
  }), /*#__PURE__*/React.createElement(RcColorPicker, _extends({}, restProps, {
    className: "custom-color-picker",
    animation: "slide-up",
    color: value && value.slice(0, 7) || '#ffffff',
    alpha: value ? getAlphaFromHex(value) : 100,
    onChange: onPickerChange
  }), /*#__PURE__*/React.createElement("span", {
    className: "react-custom-trigger"
  })), /*#__PURE__*/React.createElement("span", {
    className: "color-picker-text"
  }, value)))), errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "mobile-form-item-error-explain"
  }, errorMessage));
};

var ColorPicker = connect(ColorPickerRaw, mapProps({
  title: true,
  description: 'extra',
  required: true
}, function (props, field) {
  var _field$errors;

  return _objectSpread2(_objectSpread2({}, props), {}, {
    errorMessage: field === null || field === void 0 ? void 0 : (_field$errors = field.errors) === null || _field$errors === void 0 ? void 0 : _field$errors[0]
  });
}));

var _excluded$g = ["onSubmit"];
var Submit = observer(function (_ref) {
  var onSubmit = _ref.onSubmit,
      props = _objectWithoutProperties(_ref, _excluded$g);

  var form = useForm();
  return /*#__PURE__*/React.createElement(_Button, _extends({
    type: "primary"
  }, props, {
    loading: props.loading !== undefined ? props.loading : form.submitting,
    onClick: function onClick(e) {
      if (props.onClick) {
        props.onClick(e);
      }

      if (onSubmit) {
        form.submit(onSubmit);
      }
    }
  }), props.children);
}, {
  forwardRef: true
});

var formInstance = createForm({
  validateFirst: true
});
var SchemaField = createSchemaField({
  components: {
    FormItem: FormItem,
    Input: Input,
    Textarea: Textarea,
    InputNumber: InputNumber,
    DatePicker: DatePicker,
    Checkbox: CheckboxBoolean,
    Switch: Switch,
    CheckboxGroup: CheckboxGroup,
    Picker: Picker,
    ImagePicker: ImagePicker,
    RadioGroup: RadioGroup,
    Calendar: Calendar,
    Range: Range,
    Slider: Slider,
    Stepper: Stepper,
    RichEditor: RichEditor,
    ColorPicker: ColorPicker
  }
}); // eslint-disable @typescript-eslint/no-shadow

var MobileForm = function MobileForm(props) {
  document.getElementsByTagName('body')[0].style.overflowY = 'scroll';
  var schema = props.schema;
  return /*#__PURE__*/React.createElement(FormProvider, {
    form: formInstance
  }, /*#__PURE__*/React.createElement(_List, null, /*#__PURE__*/React.createElement(SchemaField, {
    schema: schema
  }), /*#__PURE__*/React.createElement(Submit, {
    onSubmit: function onSubmit(values) {
      return new Promise(function (resolve) {
        setTimeout(function () {
          console.log(values);
          resolve();
        }, 2000);
      });
    }
  }, "\u63D0\u4EA4")), /*#__PURE__*/React.createElement(FormConsumer, null, function (f) {
    return console.log(JSON.stringify(f.values, null, 2));
  }));
};

var _FormilySchemaDefinit;

/**
 * 统一的Json Schema数据是基于form-render 1.x中的设计器fr-generator产出的，因此这套数据有些地方与formily的数据格式并不一致，需要将数据转换为formily格式的数据
 * 此处主要是处理form-render到formily的数据转换以及antd到antd-mobile的组件库转换
 */
// form-render组件映射规则
var mapping = {
  default: 'input',
  string: 'input',
  array: 'list',
  boolean: 'checkbox',
  integer: 'number',
  number: 'number',
  object: 'map',
  html: 'html',
  'string:upload': 'upload',
  'string:url': 'url',
  'string:dateTime': 'date',
  'string:date': 'date',
  'string:year': 'date',
  'string:month': 'date',
  'string:week': 'date',
  'string:quarter': 'date',
  'string:time': 'time',
  'string:textarea': 'textarea',
  'string:color': 'color',
  'string:image': 'imageInput',
  'range:time': 'timeRange',
  'range:dateTime': 'dateRange',
  'range:date': 'dateRange',
  'range:year': 'dateRange',
  'range:month': 'dateRange',
  'range:week': 'dateRange',
  'range:quarter': 'dateRange',
  '*?enum': 'radio',
  '*?enum_long': 'select',
  'array?enum': 'checkboxes',
  'array?enum_long': 'multiSelect',
  '*?readOnly': 'html'
}; // formily schema数据结构

var FormilySchemaDefinition = (_FormilySchemaDefinit = {
  version: undefined,
  name: undefined,
  title: undefined,
  description: undefined,
  default: undefined,
  readOnly: undefined,
  writeOnly: undefined,
  type: undefined,
  enum: undefined,
  const: undefined,
  multipleOf: undefined,
  maximum: undefined,
  exclusiveMaximum: undefined,
  minimum: undefined,
  exclusiveMinimum: undefined,
  maxLength: undefined,
  minLength: undefined,
  pattern: undefined,
  maxItems: undefined,
  minItems: undefined,
  uniqueItems: undefined,
  maxProperties: undefined,
  minProperties: undefined,
  required: undefined,
  format: undefined,

  /** nested json schema spec **/
  properties: undefined,
  items: undefined,
  additionalItems: undefined,
  patternProperties: undefined,
  additionalProperties: undefined
}, _defineProperty(_FormilySchemaDefinit, 'x-index', undefined), _defineProperty(_FormilySchemaDefinit, 'x-pattern', undefined), _defineProperty(_FormilySchemaDefinit, 'x-display', undefined), _defineProperty(_FormilySchemaDefinit, 'x-validator', undefined), _defineProperty(_FormilySchemaDefinit, 'x-decorator', undefined), _defineProperty(_FormilySchemaDefinit, 'x-decorator-props', undefined), _defineProperty(_FormilySchemaDefinit, 'x-component', undefined), _defineProperty(_FormilySchemaDefinit, 'x-component-props', undefined), _defineProperty(_FormilySchemaDefinit, 'x-reactions', undefined), _defineProperty(_FormilySchemaDefinit, 'x-content', undefined), _defineProperty(_FormilySchemaDefinit, 'x-visible', undefined), _defineProperty(_FormilySchemaDefinit, 'x-hidden', undefined), _defineProperty(_FormilySchemaDefinit, 'x-disabled', undefined), _defineProperty(_FormilySchemaDefinit, 'x-editable', undefined), _defineProperty(_FormilySchemaDefinit, 'x-read-only', undefined), _defineProperty(_FormilySchemaDefinit, 'x-read-pretty', undefined), _FormilySchemaDefinit); // form-render的schema中获取需要渲染的widget名称

var getWidgetName = function getWidgetName(schema) {
  var _mapping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : mapping;

  var type = schema.type,
      format = schema.format,
      enums = schema.enum,
      readOnly = schema.readOnly,
      widget = schema.widget; // 如果已经注明了渲染widget，那最好
  // if (schema['ui:widget']) {
  //   return schema['ui:widget'];
  // }

  var list = []; // 只读

  if (readOnly) {
    list.push("".concat(type, "?readOnly"));
    list.push('*?readOnly');
  } // 枚举类型，分情况渲染不同的组件


  if (enums) {
    // 根据enum长度来智能选择控件，同时会有兜底策略
    if (Array.isArray(enums) && (type === 'array' && enums.length > 6 || type !== 'array' && enums.length > 2)) {
      list.push("".concat(type, "?enum_long"));
      list.push('*?enum_long');
    } else {
      list.push("".concat(type, "?enum")); // array 默认使用list，array?enum 默认使用checkboxes，*?enum 默认使用select

      list.push('*?enum');
    }
  } // 自定义组件widget


  var finalWidget = widget || format;

  if (finalWidget) {
    list.push("".concat(type, ":").concat(finalWidget));
  } // 放在最后兜底，其他都不match时使用type默认的组件


  list.push(type);
  var found = ''; // 从组件映射mapping中查找到list中第一个匹配的组件名称进行渲染

  list.some(function (item) {
    found = _mapping[item];
    return !!found;
  });
  return found;
}; // fr到formily的组件映射，即antd到antd-mobile的组件映射规则


var formRenderToFormilyMapping = {
  input: 'Input',
  textarea: 'Textarea',
  number: 'InputNumber',
  date: 'DatePicker',
  dateRange: 'Calendar',
  checkbox: 'Checkbox',
  switch: 'Switch',
  checkboxes: 'CheckboxGroup',
  multiSelect: 'CheckboxGroup',
  select: 'Picker',
  upload: 'ImagePicker',
  radio: 'RadioGroup',
  range: 'Range',
  slider: 'Slider',
  color: 'ColorPicker',
  richEditor: 'RichEditor'
}; // 获得propsSchema的children

var getChildren2 = function getChildren2(schema) {
  if (!schema) return [];
  var properties = schema.properties,
      items = schema.items,
      type = schema.type;

  if (!properties && !items) {
    return [];
  }

  var schemaSubs = {};

  if (type === 'object') {
    schemaSubs = properties;
  }

  if (type === 'array') {
    schemaSubs = items.properties;
  }

  return Object.keys(schemaSubs).map(function (name) {
    return {
      schema: schemaSubs[name],
      name: name
    };
  });
}; // form-render的schema 转为 formily的schema


var frToFormily = function frToFormily(frSchemaRaw) {
  var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var frSchema = frSchemaRaw;
  var formRenderComponent = getWidgetName(frSchema);
  console.log('formRenderComponent: ', formRenderComponent);
  var isObj = frSchema.type === 'object' && frSchema.properties;
  var isList = frSchema.type === 'array' && frSchema.items && frSchema.items.properties;
  var hasChildren = isObj || isList;

  if (!hasChildren) {
    if (frSchema.enum && Array.isArray(frSchema.enum) && frSchema.enumNames && Array.isArray(frSchema.enumNames)) {
      var list = frSchema.enum.map(function (item, idx) {
        return {
          value: item,
          label: frSchema.enumNames[idx]
        };
      });
      frSchema.enum = list;
    }
  } else {
    var childrenList = getChildren2(frSchema);
    childrenList.forEach(function (item) {
      if (isObj) {
        frSchema.properties[item.name] = frToFormily(item.schema, frSchema, item.name);
      }

      if (isList) {
        frSchema.items.properties[item.name] = frToFormily(item.schema, frSchema, item.name);
      }
    });
  }

  var xComponent = frSchema.widget ? formRenderToFormilyMapping[frSchema.widget] : formRenderToFormilyMapping[formRenderComponent];
  console.log('xComponent: ', xComponent);

  if (xComponent) {
    frSchema['x-component'] = xComponent;
  }

  if (frSchema.props) {
    frSchema['x-component-props'] = frSchema.props;
  }

  delete frSchema.widget;
  delete frSchema.props;
  delete frSchema.enumNames;

  if (key) {
    frSchema.name = key;
    frSchema.key = key;
  }

  if (parent && key && (parent === null || parent === void 0 ? void 0 : parent.required) && Array.isArray(parent === null || parent === void 0 ? void 0 : parent.required)) {
    if (parent.required.indexOf(key) > -1) {
      frSchema.required = true;
    }
  } // 将所有进行转换的数据，根据formily的json schema数据格式进行校验，将不属于formily定义的属性转移至x-componet-props中，这样才能在mapProps中接收


  for (var _i = 0, _Object$entries = Object.entries(frSchema); _i < _Object$entries.length; _i++) {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        _key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (!FormilySchemaDefinition.hasOwnProperty(_key)) {
      if (frSchema['x-component']) {
        if (!frSchema['x-component-props']) {
          frSchema['x-component-props'] = {};
        }

        frSchema['x-component-props'][_key] = value;
        delete frSchema[_key];
      }
    }
  }

  console.log('转换为formily格式的schema: ', frSchema);
  return frSchema;
};

var css_248z$5 = ".label-row.required::before {\n  content: \"*\";\n  display: inline-block;\n  margin-right: 4px;\n  color: #ff4d4f;\n  font-size: 17px;\n  font-family: SimSun;\n}\n.label-column {\n  display: block;\n  color: #000;\n  font-size: 17px;\n  text-align: left;\n  white-space: nowrap;\n  overflow: hidden;\n  margin-left: 15px;\n  padding: 2px 0;\n  padding-top: 12px;\n}\n.label-column.required::before {\n  content: \"*\";\n  color: #ff4d4f;\n  font-size: 17px;\n  font-family: SimSun;\n}\n.label-column-no-gutter {\n  padding-top: 2px;\n  margin-left: 0;\n}\n.mobile-form-item-error-explain {\n  margin: 7px 0 10px 0;\n  padding-left: 15px;\n  color: #ff4d4f;\n}\n.am-list-content {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.customPickerChildren {\n  font-size: 17px;\n  position: relative;\n  padding: 0 15px;\n}\n.customPickerChildren::after {\n  content: \"\";\n  position: absolute;\n  background-color: #ddd;\n  display: block;\n  z-index: 1;\n  top: auto;\n  right: auto;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  transform-origin: 50% 100%;\n  transform: scaleY(0.33);\n}\n.customPickerChildren .contentBox {\n  display: flex;\n  height: 44px;\n  align-items: center;\n}\n.customPickerChildren .contentBox .childrenLeft {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.customPickerChildren .contentBox .childrenRight {\n  font-size: 15px;\n  text-align: right;\n  line-height: 44px;\n  color: #888;\n}\n.customPickerChildren .childrenValue {\n  display: flex;\n  height: 44px;\n  line-height: 44px;\n}\n";
styleInject(css_248z$5);

// 入口

var FormRenderMobile = function FormRenderMobile(props) {
  console.log('props: ', props);
  var schemaFromFr = props.schema;
  var schema = frToFormily(schemaFromFr);
  return /*#__PURE__*/React.createElement(MobileForm, {
    schema: schema
  });
};

export default FormRenderMobile;
